import React from "react";

import { Col, Row } from "antd";

import Box from "./box";

const Formulario = () => {
    return (
        <>
            <div className="site-card-wrapper">
                <Row gutter={8}>
                    <Col sm={24} lg={12}>
                        <Box />
                    </Col>
                </Row>
            </div>
        </>
    );
};
export default Formulario;
